// extracted by mini-css-extract-plugin
module.exports = {"overlay":"NotificationOverlay_overlay__1uUgt","invisible":"NotificationOverlay_invisible__3Zp5f"};